import React, { useContext } from 'react';
import { Link, routeContext } from 'react-router5';
import { useLocale } from 'locale';
import Controls from './Controls';
import WrapperFreeUniversalCard, { DefaultUniversalCardProps } from '../UniversalCard/WrapperFreeUniversalCard';
import { CardWithControlsInactive, CardWithControlsWrapper, CardWithControlsWrapperPadding, ControlsDiviwer } from './styled';
import { CardEventSource } from 'utils/entities';
import { cardShareUrl, handleCardShare } from 'helpers/share-helpers';
import { routeByPoiType } from 'utils/marketplaceRoutes';
import ListViewUniversalCard from 'components/cards/new-layout/list-view-card';


export type CardWithControlsProps = DefaultUniversalCardProps & {
  isActive?: boolean;
  eventSource: CardEventSource;
  sectionName?: string;
  withPaddingBottom?: boolean;
  isListCard?: boolean;
};

const CardWithControls: React.FC<CardWithControlsProps> = (props) => {
  const {
    isInactive,
    id,
    streetNumber,
    streetName,
    type,
    onlyOneImageShouldBeDisplayed,
    eventSource,
    disableSwipe,
    isListCard,
  } = props;

  const router = useContext(routeContext);
  const { t } = useLocale();

  const url = cardShareUrl(router, id, type);

  return (
    <CardWithControlsWrapper isInactive={isInactive} isListCard={isListCard}>
      {isInactive ? <CardWithControlsInactive /> : null}
      <CardWithControlsWrapperPadding isListCard={isListCard}>
        <Link
          data-auto="listed-bulletin-clickable"
          routeName={routeByPoiType(type)}
          routeParams={{ id, tracking_event_source: eventSource }}
          ListViewUniversalCard
        >
          {isListCard ? (
            <ListViewUniversalCard
              {...props}
              small
            />
          ) : (
            <WrapperFreeUniversalCard
              {...props}
              withPaddingBottom
              showPriceDropLabel
              onlyOneImageShouldBeDisplayed={onlyOneImageShouldBeDisplayed}
              disableSwipe={disableSwipe}
            />
          )}
        </Link>
      </CardWithControlsWrapperPadding>
      {isListCard ? <ControlsDiviwer /> : null}
      <Controls
        isInactive={isInactive}
        id={id}
        handleShare={handleCardShare(streetNumber, streetName, url, t)}
        agentText={t('listingCard.contactAgent')}
        copyText={url}
      />
    </CardWithControlsWrapper>
  );
};

export default CardWithControls;
